<template>
  <base-section id="affiliates" class="grey lighten-4" space="36">
    <v-container>

      
<!-- {{ urls[2] }} -->

      <base-section-heading title="Sponsors" />

      <v-slide-group >
        <template v-for="n in 3">
          <v-slide-item :key="n" class="align-self-center">


            <a :href="urls[n-1]" target="_partners">
              <base-img :src="require(`@/assets/sponsors/logo-${n}.jpg`)" color="grey" contain height="50" width="128" />
            </a>
          </v-slide-item>

          <v-responsive v-if="n < 3" :key="`divider-${n}`" class="text-center" height="56" width="48">
            <v-divider vertical />
          </v-responsive>
        </template>
      </v-slide-group>
    </v-container>


  </base-section>
</template>

<script>
  export default {
    name: 'SectionAffiliates',
    data() {
      return {
        urls: ['https://www.paardekooper.nl', 'https://the-music-house.com', 'http://setup.nl'],
        partners: {
          paardekoper: {
            url: 'https://www.paardekooper.nl',
            logo: 'logo-1.jpg'
          },
          setup: {
            url: 'https://www.paardekooper.nl',
            logo: 'logo-1.jpg'
          },
          MUSICHOUSE: {
            url: 'https://www.paardekooper.nl',
            logo: 'logo-1.jpg'
          },
          // oneseconds: {
          //   url: 'www.oneseconds.com',
          //   logo: 'logo-2.png'

          // },
          // schaalwerk: {
          //   url: 'www.schaalwerk.nl',
          //   logo: 'logo-3.png'

          // },
        }
      }
    },
  }
</script>
<style scoped>
  /* :src="require(`@/assets/partners/logo-${n}.png`)" */
  .sponsors {}
</style>